/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreateGameSessionRequestDto model module.
 * @module model/CreateGameSessionRequestDto
 * @version v0
 */
class CreateGameSessionRequestDto {
    /**
     * Constructs a new <code>CreateGameSessionRequestDto</code>.
     * Game session creation data
     * @alias module:model/CreateGameSessionRequestDto
     * @param sessionType {String} Type of the session (e.g., CAUSA_EMOCION, INTERPRETACION, or comma-separated combinations)
     */
    constructor(sessionType) { 
        
        CreateGameSessionRequestDto.initialize(this, sessionType);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, sessionType) { 
        obj['sessionType'] = sessionType;
    }

    /**
     * Constructs a <code>CreateGameSessionRequestDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateGameSessionRequestDto} obj Optional instance to populate.
     * @return {module:model/CreateGameSessionRequestDto} The populated <code>CreateGameSessionRequestDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateGameSessionRequestDto();

            if (data.hasOwnProperty('sessionType')) {
                obj['sessionType'] = ApiClient.convertToType(data['sessionType'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CreateGameSessionRequestDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateGameSessionRequestDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CreateGameSessionRequestDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['sessionType'] && !(typeof data['sessionType'] === 'string' || data['sessionType'] instanceof String)) {
            throw new Error("Expected the field `sessionType` to be a primitive type in the JSON string but got " + data['sessionType']);
        }

        return true;
    }


}

CreateGameSessionRequestDto.RequiredProperties = ["sessionType"];

/**
 * Type of the session (e.g., CAUSA_EMOCION, INTERPRETACION, or comma-separated combinations)
 * @member {String} sessionType
 */
CreateGameSessionRequestDto.prototype['sessionType'] = undefined;






export default CreateGameSessionRequestDto;

